import React from "react";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import FormatQuote from "@material-ui/icons/FormatQuote";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardAvatar from "components/Card/CardAvatar.js";
import Table from "components/Table/Table.js";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

import testimonialsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/testimonialsStyle.js";

import cardProfile1Square from "assets/img/bangle-size-guide.jpg";

const useStyles = makeStyles(testimonialsStyle);

export default function InshaBanglesSizeGuide({ ...rest }) {
  const classes = useStyles();
  return (
    <div className="cd-section" {...rest}>
      {/* <Helmet>
        <title>Bangles Size Guide</title>
      </Helmet> */}
      <Helmet>
        <html lang="en" />

        <title>Bangles Size Guide (MM, Inches, Chart) | INSHA BANGLES</title>

        <meta
          name="description"
          content="Take an existing bangle that fits you comfortably and place it on a flat surface, use a scale or ruler to measure the inner diameter of the bangle from one inner edge to the other, note down the measurement accurately in millimeters (MM) or inches for better precision, refer to the size chart provided and match your measurement with the corresponding bangle size, select the size that best matches your measurement to ensure a perfect and comfortable fit,Find your perfect bangle size using our complete size guide. Check MM, inches, and gram measurements with easy steps to measure bangles correctly."
        />

        <meta
          name="keywords"
          content="bangle size guide, how to measure bangle size, bangle measurement in mm, bangle size in inches, inner diameter bangle measurement, perfect bangle size chart, how to find bangle size at home, bangle fitting guide, jewellery size measurement guide, bangles size chart India, correct bangle size measurement, measure bangle inner diameter, women bangle size guide, bangles size conversion chart, accurate bangle sizing method, jewellery sizing tips, how to choose correct bangle size, bangle measurement step by step, bangle size calculator guide, bangles fitting instructions,bangles size guide, bangle size chart, mm to inch bangles, indian bangle size, how to measure bangle size, jewellery size guide"
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href="https://inshabangles.com/insha-bangles-size-guide"
        />

        {/* Open Graph */}
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Bangles Size Guide | INSHA BANGLES"
        />
        <meta
          property="og:description"
          content="Check complete bangles size chart with mm, inches and step-by-step guide."
        />
        <meta
          property="og:url"
          content="https://inshabangles.com/insha-bangles-size-guide"
        />
        <meta
          property="og:image"
          content="https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: "Bangles Size Guide",
            description:
              "Complete guide to measure bangles size with chart in mm and inches.",
            author: {
              "@type": "Organization",
              name: "INSHA BANGLES",
            },
            publisher: {
              "@type": "Organization",
              name: "INSHA BANGLES",
            },
          })}
        </script>
      </Helmet>
      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 100,
          color: "dark",
        }}
      />
      <div className={classes.testimonials + " " + classes.sectionImage}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={6}
              className={
                classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
              }
            >
              <h1 className={classes.title}>
                Bangles Size Guide (MM, Inches & Chart)
              </h1>
              {/* <h2 className={classes.title}>Insha Bangle Size Guide</h2> */}
              <h5 className={classes.description}>
                This is a chart that will be extremely helpful for you to
                determine the bangle size that you need.
              </h5>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <Card testimonial className={classes.card1}>
                <div className={classes.icon}>
                  <FormatQuote />
                </div>
                <CardBody>
                  <h5 className={classes.cardDescription}>
                    Bangles Size (Indian MM/Gram)
                  </h5>
                  <Table
                    tableData={[
                      ["1x8", "38.1MM"],
                      ["1x10", "41.2MM/0.063 Gram"],
                      ["1x12", "44.4MM/0.068 Gram"],
                      ["1x14", "47.6MM"],
                      ["2x0", "50.8MM/0.076 Gram"],
                      ["2x2", "53.9MM"],
                      ["2x4", "57.1MM/0.079 Gram"],
                      ["2x6", "60.3MM"],
                      ["2x8", "63.5MM/0.096 Gram"],
                      ["2x10", "66.6MM/0.100 Gram"],
                      ["2x12", "69.8MM/0.103 Gram"],
                      ["2x14", "73.0MM"],
                      ["3x0", "76.3MM"],
                    ]}
                  />
                </CardBody>
                <CardFooter testimonial>
                  <h4 className={classes.cardTitle}>
                    Steps to know your Bangles Size:
                  </h4>
                  <h6 className={classes.cardCategory}>
                    1. TAKE A BANGLE AND PLACE IT ON A SCALE.
                    <br /> 2. MEASURE THE INNER DIAMETER AS SHOWN IN THE
                    PICTURE.
                    <br /> 3. USE THE ABOVE SHOWN CHART TO DETERMINE YOUR
                    BANGLES SIZE
                  </h6>
                  <CardAvatar testimonial testimonialFooter>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        src={cardProfile1Square}
                        alt="Bangles size measurement chart"
                      />
                    </a>
                  </CardAvatar>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card testimonial className={classes.card1}>
                <div className={classes.icon}>
                  <FormatQuote />
                </div>
                <CardBody>
                  <h5 className={classes.cardDescription}>MM/Inches</h5>
                  <Table
                    tableData={[
                      ["1x8", "38.1MM/1.5 Inch"],
                      ["1x10", "41.2MM/1.622 Inch"],
                      ["1x12", "44.4MM/1.74 Inch"],
                      ["1x14", "47.6MM/1.87 Inch"],
                      ["2x0", "50.8MM/2 Inch"],
                      ["2x2", "53.9MM/2.12 Inch"],
                      ["2x4", "57.1MM/2.24 Inch"],
                      ["2x6", "60.3MM/2.37 Inch"],
                      ["2x8", "63.5MM/2.5 Inch"],
                      ["2x10", "66.6MM/2.62 Inch"],
                      ["2x12", "69.8MM/2.74 Inch"],
                      ["2x14", "73.0MM/2.87 Inch"],
                      ["3x0", "76.3MM/3 Inch"],
                    ]}
                  />
                </CardBody>
                <CardFooter testimonial>
                  <h4 className={classes.cardTitle}>
                    Steps to know your Bangles Size:
                  </h4>
                  <h6 className={classes.cardCategory}>
                    1. TAKE A BANGLE AND PLACE IT ON A SCALE.
                    <br /> 2. MEASURE THE INNER DIAMETER AS SHOWN IN THE
                    PICTURE.
                    <br /> 3. USE THE ABOVE SHOWN CHART TO DETERMINE YOUR
                    BANGLES SIZE
                  </h6>
                  <CardAvatar testimonial testimonialFooter>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        src={cardProfile1Square}
                        alt="Bangles size measurement chart"
                      />
                    </a>
                  </CardAvatar>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card testimonial className={classes.card1}>
                <div className={classes.icon}>
                  <FormatQuote />
                </div>
                <CardBody>
                  <h5 className={classes.cardDescription}>
                    Bangles Size (US MM/Gram)
                  </h5>
                  <Table
                    tableData={[
                      ["#1", "41.2MM/0.063 Gram"],
                      ["#2", "44.4MM/0.068 Gram"],
                      ["#3", "50.8MM/0.076 Gram"],
                      ["#4", "57.1MM/0.079 Gram"],
                      ["#5", "63.5MM/0.096 Gram"],
                      ["#6", "66.6MM/0.100 Gram"],
                      ["#7", "69.8MM/0.0103 Gram"],
                      ["#8", "76.3MM"],
                    ]}
                  />
                </CardBody>
                <CardFooter testimonial>
                  <h4 className={classes.cardTitle}>
                    Steps to know your Bangles Size:
                  </h4>
                  <h6 className={classes.cardCategory}>
                    1. TAKE A BANGLE AND PLACE IT ON A SCALE.
                    <br /> 2. MEASURE THE INNER DIAMETER AS SHOWN IN THE
                    PICTURE.
                    <br /> 3. USE THE ABOVE SHOWN CHART TO DETERMINE YOUR
                    BANGLES SIZE
                  </h6>
                  <CardAvatar testimonial testimonialFooter>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        src={cardProfile1Square}
                        alt="Bangles size measurement chart"
                      />
                    </a>
                  </CardAvatar>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <Footer />
    </div>
  );
}
